/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Field_Name_LabelInputs */

const en_contact_field_name_label = /** @type {(inputs: Contact_Field_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full name`)
};

/**
* | output |
* | --- |
* | "Full name" |
*
* @param {Contact_Field_Name_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_field_name_label = /** @type {((inputs?: Contact_Field_Name_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Field_Name_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_field_name_label(inputs)
});